import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withStyles, TableContainer, Table, TableBody, TablePagination } from "@material-ui/core";
import t from "../../../../languages/pl";
import TableHeader from '../../../Common/TableHeader';
import SavedLocationRow from './SavedLocationRow';
import { notArrayOrEmpty } from '../../../../utils/helpers';
import NoData from './../../../Common/NoDataRow';
import guid from './../../../../utils/guid';
import ConfirmationDialog from "../../../Common/ConfirmationDialog";

const useStyles = theme => ({
    container: {
        maxHeight: 400,
        overflowX: "hidden"
    },
    table: {
        margin: theme.spacing(1),
    },
    cell: {
        textAlign: "center",
        padding: theme.spacing(1)
    },
    addressCell: {
        width: 150,
    },
    radioCell: {
        width: 70
    },
    radio: {
        padding: 0,
        color: theme.palette.secondary.main
    }
});

const tableHeader = ["Wybierz", t.name, t.address, t.type, t.manage];

const SavedLocationsTable = props => {
    const { classes, locations, selected, coords, onNewSelected, onPoiDelete, onPoiUpdate, onExpand, expandedId,
         onSearch, dataAfterSearch } = props;
    const [quantity, setQuantity] = useState(20);
    const [page, setPage] = useState(0);
    const [filteredPoi, setFilteredPoi] = useState([]);
    const [ poiDeleteDialog, setPoiDeleteDialog] = useState(false);
    const [ poiId, setPoiId] = useState(null);

    useEffect(() => {
        let filtered = locations.slice(page * quantity, page * quantity + quantity);
        setFilteredPoi(filtered);
    }, [locations, quantity, page]);

    const handleLocationSelect = (id) => {
        let newSelected = filteredPoi.find(element => element.poi_id === id);
        onNewSelected && onNewSelected(newSelected);
    };

    const handleExpand = (id) => {
        let newSelected = filteredPoi.find(element => element.poi_id === id);
        onNewSelected && onNewSelected(newSelected);
        onExpand(id);
    };

    const onDeletePoiClick = (id) => {
        setPoiDeleteDialog(true);
        setPoiId(id);
    };

    const onConfirmDeletePoi = (id) => {
        onPoiDelete(id);
    };

    const handleDisplayedRows = (from, to, count) => {
        return `${from}-${to} z ${count}`;
    };

    const handleUpdatePoi = (data) =>{
        onPoiUpdate(data);
    };

    const handleChangeRowPerPage = e => {
        setPage(Math.floor(page *(quantity / e.target.value)));
        setQuantity(e.target.value);
    };

    const printRows = data => {
        if(notArrayOrEmpty(data))
            return <NoData colSpan={5}/>;
        return data.map(row => (
            <SavedLocationRow
                key={guid()}
                data={row}
                elementIdIdentifier="poi_id"
                onRadioClick={handleLocationSelect}
                selectedId={selected && selected.poi_id}
                expandedId={expandedId}
                onExpand={handleExpand}
                coords={coords}
                onDeleteClick={(id) => onDeletePoiClick(id)}
                onSaveClick={handleUpdatePoi}
                onSearch={onSearch}
                dataAfterSearch={dataAfterSearch}
            />
        ));
    };

    return (
        <>
            <TableContainer className={classes.container}>
                <Table stickyHeader className={classes.table}>
                    <TableHeader data={tableHeader} />
                    <TableBody>
                        {printRows(filteredPoi)}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 20, 30]}
                component="div"
                labelRowsPerPage={t.quantityOfDisplayingElements}
                nextIconButtonText={t.nextPage}
                backIconButtonText={t.previousPage}
                count={locations.length}
                rowsPerPage={quantity}
                page={page}
                onChangePage={(obj, number) => setPage(number)}
                onChangeRowsPerPage={handleChangeRowPerPage}
                labelDisplayedRows={({ from, to, count }) => handleDisplayedRows(from, to, count)}
            />
            <ConfirmationDialog
                open={poiDeleteDialog}
                onClose={() => setPoiDeleteDialog(false)}
                id={poiId}
                onSubmit={(id) => onConfirmDeletePoi(id)}
                action={t.deletePoiConfirmation}
            />
        </>
    );
};

SavedLocationsTable.propTypes = {
    classes: PropTypes.object,
    locations: PropTypes.array,
    selected: PropTypes.object,
    coords: PropTypes.object,
    onNewSelected: PropTypes.func,
    onPoiDelete: PropTypes.func,
    onPoiUpdate: PropTypes.func,
    onExpand: PropTypes.func,
    onSearch: PropTypes.func,
    expandedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    dataAfterSearch: PropTypes.object
};

export default withStyles(useStyles)(SavedLocationsTable);

